<!-- ── Section header ─────────────────────────────────────────────────────── -->
<div class="srl-header">
  <div class="srl-header__text">
    <h2 class="srl-header__title">{{ 'settings.splitting_rules_title' | translate }}</h2>
    <p class="srl-header__desc">{{ 'settings.splitting_rules_description' | translate }}</p>
  </div>
  <ui-button
    type="secondary"
    [label]="'settings.splitting_rules_add' | translate | uppercase"
    icon="plus"
    iconPosition="start"
    (click)="addRule.emit()">
  </ui-button>
</div>

<!-- ── List card ──────────────────────────────────────────────────────────── -->
<div class="srl-card">

  <!-- Loading -->
  <div class="srl-state" *ngIf="loading">
    <mat-spinner diameter="24"></mat-spinner>
  </div>

  <!-- Empty state -->
  <div class="srl-empty" *ngIf="!loading && (!rules || rules.length === 0)">
    <div class="srl-empty__icon">
      <ui-svg-icon svgIcon="quotations" size="large"></ui-svg-icon>
    </div>
    <span class="srl-empty__title">{{ 'settings.splitting_rules_empty_title' | translate }}</span>
    <p class="srl-empty__body">{{ 'settings.splitting_rules_empty_body' | translate }}</p>
    <ui-button
      type="secondary"
      [label]="'settings.splitting_rules_add' | translate | uppercase"
      icon="plus"
      iconPosition="start"
      (click)="addRule.emit()">
    </ui-button>
  </div>

  <ng-container *ngIf="!loading && rules && rules.length > 0">

    <!-- Column headers -->
    <div class="srl-col-header">
      <div class="srl-col-header__rule">{{ 'settings.splitting_rules_col_rules' | translate }} ({{ rules.length }})</div>
      <div class="srl-col-header__enabled">{{ 'settings.splitting_rules_col_enabled' | translate }}</div>
      <div class="srl-col-header__actions"></div>
    </div>

    <!-- Rule rows -->
    <div class="srl-row"
      *ngFor="let rule of rules"
      [class.srl-row--inactive]="!rule.active && confirmDeleteId !== rule.id"
      [class.srl-row--confirming]="confirmDeleteId === rule.id">

      <!-- ── Delete confirmation overlay ── -->
      <div class="srl-confirm" *ngIf="confirmDeleteId === rule.id">
        <ui-svg-icon class="srl-confirm__icon" svgIcon="delete" size="medium"></ui-svg-icon>
        <span class="srl-confirm__msg"
          [innerHTML]="'settings.splitting_rules_delete_confirm' | translate : { name: rule.name }">
        </span>
        <div class="srl-confirm__btns">
          <button type="button" class="srl-btn srl-btn--danger" (click)="confirmDelete()">{{ 'settings.splitting_rules_delete' | translate }}</button>
          <button type="button" class="srl-btn srl-btn--ghost" (click)="cancelDelete()">{{ 'settings.splitting_rules_cancel' | translate }}</button>
        </div>
      </div>

      <!-- ── Normal row content ── -->
      <ng-container *ngIf="confirmDeleteId !== rule.id">

        <!-- Text block -->
        <div class="srl-row__text">
          <span class="srl-row__name">{{ rule.name }}</span>
          <div class="srl-row__meta">
            <span class="srl-row__summary">{{ splitSummary(rule) }}</span>
            <span class="srl-dot">·</span>
            <span class="srl-row__applicability">
              {{ 'settings.splitting_rules_applies_to' | translate }} <strong>{{ applicabilityLabel(rule) }}</strong>
            </span>
          </div>
        </div>

        <!-- Toggle -->
        <div class="srl-row__toggle">
          <mat-slide-toggle
            [checked]="rule.active"
            (change)="onToggle(rule)"
            color="primary"
            [attr.aria-label]="rule.active ? ('settings.splitting_rules_disable' | translate) : ('settings.splitting_rules_enable' | translate)">
          </mat-slide-toggle>
        </div>

        <!-- Action buttons -->
        <div class="srl-row__actions">
          <button type="button" class="srl-icon-btn" (click)="edit.emit(rule)" [title]="'settings.splitting_rules_edit' | translate">
            <ui-svg-icon svgIcon="edit" size="medium"></ui-svg-icon>
          </button>
          <button type="button" class="srl-icon-btn srl-icon-btn--danger" (click)="requestDelete(rule.id)" [title]="'settings.splitting_rules_delete_title' | translate">
            <ui-svg-icon svgIcon="delete" size="medium"></ui-svg-icon>
          </button>
        </div>

      </ng-container>
    </div>

  </ng-container>
</div>
